/**
 * HW Product Media Gallery - JS
 * Extracted from blocks/_hw-product-media-gallery.liquid
 */

(function () {
  // Run for all gallery instances
  const galleries = document.querySelectorAll('.hw-product-media-gallery');
  
  galleries.forEach(function(root) {
    initGallery(root);
  });
  
  /**
   * Align slideshow infinite with data-carousel-loop (carousel presentation only).
   * Refreshes theme and HW arrow disabled states after attribute changes.
   *
   * @param {HTMLElement} wrapper
   */
  function syncGalleryCarouselLoop(wrapper) {
    if (wrapper.getAttribute('data-presentation') !== 'carousel') {
      return;
    }

    const slideshow = wrapper.querySelector('slideshow-component');
    if (!slideshow) {
      return;
    }

    const shouldLoop = wrapper.getAttribute('data-carousel-loop') !== 'false';

    if (shouldLoop) {
      slideshow.setAttribute('infinite', '');
    } else {
      slideshow.removeAttribute('infinite');
    }

    const current =
      typeof slideshow.current === 'number' ? slideshow.current : 0;
    slideshow.current = current;

    const nav = wrapper.querySelector('.hw-carousel-navigation');
    if (nav) {
      slideshow.dispatchEvent(
        new CustomEvent('slideshow:select', {
          bubbles: true,
          detail: { index: current },
        })
      );
    }
  }

  /**
   * Copy carousel nav sizing/inset custom properties after nav is moved into slideshow-container.
   *
   * @param {HTMLElement} sourceEl
   * @param {HTMLElement} targetEl
   */
  function syncCarouselNavVars(sourceEl, targetEl) {
    if (!sourceEl || !targetEl) {
      return;
    }

    const sourceStyle = getComputedStyle(sourceEl);
    const varNames = [
      '--hw-carousel-arrows-padding-inline',
      '--hw-carousel-arrows-padding-inline-desktop',
      '--icon-width',
      '--icon-height',
      '--icon-width-desktop',
      '--icon-height-desktop',
      '--arrow-button-width',
      '--arrow-button-height',
      '--arrow-button-width-desktop',
      '--arrow-button-height-desktop',
    ];

    varNames.forEach(function (name) {
      const value = sourceStyle.getPropertyValue(name);
      if (value) {
        targetEl.style.setProperty(name, value.trim());
      }
    });
  }

  function relocateGalleryCarouselNav(root) {
    const wrapper = root.querySelector('.hw-media-gallery-wrapper');
    if (!wrapper) {
      return;
    }

    if (wrapper.getAttribute('data-hw-custom-gallery-arrows') !== 'true') {
      syncGalleryCarouselLoop(wrapper);
      return;
    }

    const host = wrapper.querySelector('[data-hw-gallery-carousel-nav-host]');
    const nav = host && host.querySelector('.hw-carousel-navigation');
    const slideshow = wrapper.querySelector('slideshow-component');
    const container = slideshow && slideshow.querySelector('slideshow-container');
    if (!nav || !slideshow || !container) {
      syncGalleryCarouselLoop(wrapper);
      return;
    }

    const blockId = wrapper.getAttribute('data-block-id') || '';
    const slideshowId = blockId ? 'hw-pdp-gallery-' + blockId : 'hw-pdp-gallery';
    slideshow.setAttribute('data-slideshow-id', slideshowId);
    nav.setAttribute('data-target-slideshow', slideshowId);
    nav.classList.add('hw-carousel-navigation--pdp-gallery');

    if (nav.parentElement !== container) {
      container.insertBefore(nav, container.firstChild);
    }

    syncCarouselNavVars(wrapper, nav);
    syncCarouselNavVars(wrapper, container);

    const navArrows = nav.querySelector('.hw-carousel-navigation__arrows');
    if (navArrows) {
      syncCarouselNavVars(nav, navArrows);
    }

    if (host && !host.children.length) {
      host.setAttribute('hidden', '');
    }

    syncGalleryCarouselLoop(wrapper);
  }

  function initGallery(root) {
    const main = root.querySelector('.hw-product-media-gallery__main');
    if (!main) return;

    const galleryWrapper = root.querySelector('.hw-media-gallery-wrapper');
    const aside = main.querySelector('.hw-product-media-gallery__aside');
    const overlayHost =
      galleryWrapper &&
      galleryWrapper.querySelector('[data-hw-gallery-slider-overlays]');

    relocateGalleryCarouselNav(root);

    if (galleryWrapper) {
      syncGalleryCarouselLoop(galleryWrapper);

      if (!galleryWrapper.hasAttribute('data-hw-carousel-loop-resize')) {
        galleryWrapper.setAttribute('data-hw-carousel-loop-resize', 'true');
        let resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            syncGalleryCarouselLoop(galleryWrapper);
          }, 150);
        });
      }
    }

    if (!aside) return;
    const thumbnailsRow = main.querySelector('.hw-product-media-gallery__thumbnails-row');
    const hasThumbnailsAtBottom = root.getAttribute('data-thumbnails-at-bottom') === 'true';

    /**
     * Overlays render in __aside then move to the slider host. After the first move,
     * aside is empty — collect from aside (new blocks) then host (already moved).
     *
     * @returns {HTMLElement[]}
     */
    function collectGalleryOverlaysInOrder() {
      if (!aside || !overlayHost) {
        return [];
      }

      const list = [];
      const seen = new Set();

      aside.querySelectorAll('.hw-product-media-overlay').forEach(function (el) {
        if (root.contains(el)) {
          list.push(el);
          seen.add(el);
        }
      });

      overlayHost.querySelectorAll('.hw-product-media-overlay').forEach(function (el) {
        if (!seen.has(el) && root.contains(el)) {
          list.push(el);
          seen.add(el);
        }
      });

      return list;
    }

    function relocateGalleryMediaOverlays() {
      if (!overlayHost || !aside) {
        return;
      }

      const overlays = collectGalleryOverlaysInOrder();
      overlayHost.replaceChildren();

      overlays.forEach(function (overlay) {
        overlayHost.appendChild(overlay);
      });

      if (!overlayHost.children.length) {
        overlayHost.setAttribute('hidden', '');
      } else {
        overlayHost.removeAttribute('hidden');
      }
    }

    function asideHasSidebarRailContent() {
      return !!aside.querySelector('.hw-media-usps, .hw-product-info-items');
    }

    function setAsideWidthVar() {
      if (asideHasSidebarRailContent()) {
        aside.classList.add('hw-product-media-gallery__aside--has-sidebar-content');
        main.style.setProperty('--hw-media-aside-width', aside.offsetWidth + 'px');
      } else {
        aside.classList.remove('hw-product-media-gallery__aside--has-sidebar-content');
        main.style.removeProperty('--hw-media-aside-width');
      }
    }

    // Fixed isVisible function - doesn't rely on offsetParent which fails for fixed-position elements
    function isVisible(el) {
      if (!el) return false;
      var s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
    }

    function moveThumbnailsAndPatchRefs() {
      if (!hasThumbnailsAtBottom || !thumbnailsRow) return;
      const galleryMedia = root.querySelector('.hw-product-media-gallery__gallery-media');
      if (!galleryMedia) return;
      const controlsList = galleryMedia.querySelectorAll('slideshow-controls[thumbnails][pagination-position="center"]');
      if (!controlsList.length) return;

      const firstControls = controlsList[0];
      const slideshow = firstControls.closest('slideshow-component');

      controlsList.forEach(function (controls) {
        thumbnailsRow.appendChild(controls);
      });

      // Fix: Ensure correct visible control is patched into slideshow.refs
      var controlsToPatch = Array.from(controlsList).find(isVisible) || firstControls;

      if (slideshow && slideshow.refs) {
        queueMicrotask(function () {
          slideshow.refs.slideshowControls = controlsToPatch;
          const container = controlsToPatch.querySelector('[ref="thumbnailsContainer"]');
          if (container) slideshow.refs.thumbnailsContainer = container;
          const thumbs = controlsToPatch.querySelectorAll('[ref="thumbnails[]"]');
          slideshow.refs.thumbnails = thumbs ? Array.from(thumbs) : [];
        });
      }
      thumbnailsRow.removeAttribute('aria-hidden');

      function syncThumbnailActiveState(index) {
        var thumbnails = thumbnailsRow.querySelectorAll('.slideshow-controls__thumbnail, [ref="thumbnails[]"]');
        thumbnails.forEach(function (btn, i) {
          var attr = btn.getAttribute && btn.getAttribute('on:click');
          var idx = attr ? parseInt((attr.split('/').pop() || '').replace(/\?.*/, ''), 10) : i;
          if (isNaN(idx)) idx = i;
          btn.setAttribute('aria-selected', idx === index ? 'true' : 'false');
        });
      }

      var galleryMediaForEvent = root.querySelector('.hw-product-media-gallery__gallery-media');
      var slideshowForEvent = galleryMediaForEvent && galleryMediaForEvent.querySelector('slideshow-component');
      if (slideshowForEvent) {
        slideshowForEvent.addEventListener('slideshow:select', function (e) {
          if (e.detail && typeof e.detail.index === 'number') syncThumbnailActiveState(e.detail.index);
        });
        queueMicrotask(function () {
          var cur = slideshowForEvent.current;
          if (typeof cur === 'number') syncThumbnailActiveState(cur);
        });
      }

      thumbnailsRow.addEventListener('click', function (e) {
        var btn = (e.target && e.target.closest && (e.target.closest('.slideshow-controls__thumbnail') || e.target.closest('[ref="thumbnails[]"]'))) || null;
        if (!btn) return;
        var galleryMedia = root.querySelector('.hw-product-media-gallery__gallery-media');
        var slideshow = galleryMedia && galleryMedia.querySelector('slideshow-component');
        if (!slideshow || typeof slideshow.select !== 'function') return;
        var attr = btn.getAttribute && btn.getAttribute('on:click');
        var idx = attr ? parseInt((attr.split('/').pop() || '').replace(/\?.*/, ''), 10) : -1;
        if (isNaN(idx) || idx < 0) idx = (slideshow.refs && slideshow.refs.thumbnails) ? slideshow.refs.thumbnails.indexOf(btn) : -1;
        if (idx < 0) return;
        e.preventDefault();
        e.stopPropagation();
        slideshow.select(idx);
      }, true);
    }

    // Set up MutationObserver to detect when blocks are added/removed
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (
          mutation.type === 'childList' &&
          (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
        ) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        relocateGalleryMediaOverlays();
        relocateGalleryCarouselNav(root);
        if (galleryWrapper) {
          syncGalleryCarouselLoop(galleryWrapper);
        }
        setAsideWidthVar();
      }
    });
    
    observer.observe(aside, { childList: true, subtree: true });

    // Run immediately and also after delays to catch dynamically added content
    relocateGalleryMediaOverlays();
    relocateGalleryCarouselNav(root);
    if (galleryWrapper) {
      syncGalleryCarouselLoop(galleryWrapper);
    }
    setAsideWidthVar();

    // Run multiple times to catch content that renders after initial load
    [100, 500, 1000, 2000].forEach(function(delay) {
      setTimeout(function () {
        relocateGalleryMediaOverlays();
        relocateGalleryCarouselNav(root);
        if (galleryWrapper) {
          syncGalleryCarouselLoop(galleryWrapper);
        }
        setAsideWidthVar();
      }, delay);
    });
    
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setAsideWidthVar).observe(aside);
    }
    window.addEventListener('resize', setAsideWidthVar);
    
    // Only run thumbnail movement if thumbnails are at bottom
    if (hasThumbnailsAtBottom && thumbnailsRow) {
      moveThumbnailsAndPatchRefs();
    }
  }
})();
